<template>
  <span>
    <el-button type="primary" @click="showdialog">{{ title }}</el-button>
    <el-dialog
      title="选择使用返利"
      :visible.sync="dialogVisible"
      width="800px"
      top="0"
      append-to-body
    >
      <el-form ref="form" :inline="true" :model="searchForm">
        <el-form-item label="到期日:" prop="expireStartDate">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.expireStartDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
            <div style="display: inline-block; width: 10px; text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.expireEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="返利类型" prop="rebateType">
          <el-select v-model="searchForm.rebateType">
            <el-option
              v-for="(value, key) of typeList"
              :key="key"
              :value="key"
              :label="value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="() => {rest();}"
          >搜索</el-button>
        </el-form-item>
      </el-form>
      <div>
        <span
          v-if="yanzheng && setAllocatedAmount(allow) > availableRebateAmount"
          style="display: inline-block; margin-right: 10px"
        >
          当前合同最大可用返利金额：{{ $numToFixed(availableRebateAmount) }}元;
        </span>
        <span
          v-if="yanzheng && setAllocatedAmount(allow) <= availableRebateAmount"
          style="display: inline-block; margin-right: 10px"
        >
          当前合同最大可用返利金额：{{ $numToFixed(setAllocatedAmount(allow)) }}元;
        </span>
      </div>
      <el-table
        id="rabateTable"
        ref="multipleTable"
        v-loading="tableLoading"
        :data="tableData"
        style="width: 100%"
        border
        :max-height="400"
        row-key="id"
        @select="selectOne"
        @select-all="selectAll"
      >
        <el-table-column
          type="selection"
          width="50"
          reserve-selection
          align="left"
          fixed="left"
        />
        <el-table-column label="返利编号" align="left" prop="rebateNumber" />
        <el-table-column prop="strRebateType" label="返利类型" align="left" />
        <el-table-column prop="rebateAmount" label="总金额" align="right" header-align="left" />
        <el-table-column prop="grantDate" label="发放日期" align="left" />
        <el-table-column prop="expireDate" label="到期日" align="left" />
        <el-table-column
          prop="availableAmount"
          label="可用余额"
          align="right"
          header-align="left"
        />
        <el-table-column label="使用金额" align="right" header-align="left" fixed="right">
          <template v-slot="{ row }">
            <el-input-number
              v-model="row.transferAmount"
              :min="0"
              :disabled="row.isSelect"
              size="mini"
              :controls="false"
              style="width: 100%"
              @blur="transferAmountBlur(row)"
            />
          </template>
        </el-table-column>
        <template slot="append">
          <infinite-loading
            ref="infiniteLoading"
            force-use-infinite-wrapper="#rabateTable > .el-table__body-wrapper"
            :distance="10"
            @infinite="dosearch"
          >
            <div slot="no-more" style="padding: 20px">加载完成</div>
            <div slot="no-results" style="padding: 20px">暂时无数据</div>
          </infinite-loading>
        </template>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmTransfer">确认</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script type="es6">
import { selectRebateTypeList, selectAgentAvailableRebate } from '@/API';
import InfiniteLoading from 'vue-infinite-loading';
import { MathAdd, MathMulti } from '@/libs/util';
let inloading;
export default {

  components: {
    InfiniteLoading
  },

  props: {
    title: {
      type: String,
      default: '填选返利'
    },
    allow: {
      type: Number,
      default: 0
    },
    availableRebateAmount: {
      type: Number,
      default: 0
    },
    yanzheng: {
      type: Boolean,
      default: true
    },
    householdProducts: {
      type: [Boolean, Number],
      default: false
    },
    needReload: {
      type: Boolean,
      default: false
    },
    excludeList: {
      type: Array,
      default: () => { return []; }
    },
    // 客户签约类型：
    customerContractType: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      dialogVisible: false,
      searchForm: {
        rebateType: '',
        expireStartDate: '',
        expireEndDate: ''
      },
      tableLoading: false,
      tableData: [],
      multipleSelection: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      typeList: {}
    };
  },

  computed: {
    totalChoose () {
      let count = 0;
      this.multipleSelection.forEach((item) => {
        count = MathAdd(count, item.transferAmount);
      });
      return count.toFixed(2);
    },
    excludeIds () {
      let list = [];
      this.excludeList.forEach((item) => {
        list.push(item.rebateNumber);
      });
      return list;
    }
  },

  methods: {
    showdialog () {
      if (this.needReload) {
        this.rest();
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      }
      this.dialogVisible = true;
      this.selectRebateTypeList();
    },

    // 设置分配金额
    setAllocatedAmount (val) {
      if (this.$route.query.rcontractType === '换货合同') {
        return MathMulti(val, 0.3);
      }
      return val;
    },

    selectRebateTypeList () {
      let params = { agentTypeName: this.customerContractType };
      selectRebateTypeList(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.typeList = json.data;
        }
      });
    },

    dosearch ($state) {
      inloading = $state;
      if (this.page.total <= this.tableData.length && this.tableData.length) {
        $state && $state.complete();
        return;
      }
      selectAgentAvailableRebate({
        ...this.searchForm,
        lists: this.excludeIds,
        householdProducts: [1, 2].includes(Number(this.householdProducts)),
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.page.total = json.data.total;
          if (json.data.total === 0) {
            $state && $state.complete();
          }
          this.page.currentPage++;
          json.data.list.forEach((item) => {
            item.isSelect = true;
          });
          this.tableData = this.tableData.concat(json.data.list);
          this.$nextTick(() => {
            $state && $state.loaded();
          });
        }
      });
    },
    rest () {
      if (inloading) {
        inloading.reset();
      }
      this.page.currentPage = 1;
      this.page.total = 0;
      this.tableData = [];
    },
    restFormAction () {
      this.searchForm.expireEndDate = '';
      this.$refs.form.resetFields();
      this.rest();
      // this.dosearch();
    },
    selectOne (selection, row) {
      if (row.isSelect) {
        row.isSelect = false;
        row.transferAmount = row.availableAmount;
      } else {
        row.isSelect = true;
        row.transferAmount = 0;
      }
      this.multipleSelection = selection;
    },
    selectAll (selection) {
      if (selection.length) {
        selection.forEach((row) => {
          row.isSelect = false;
          row.transferAmount = row.availableAmount;
        });
      } else {
        this.tableData.forEach((row) => {
          row.isSelect = true;
          row.transferAmount = 0;
        });
      }
      this.multipleSelection = selection;
    },
    confirmTransfer () {
      // 判断 订单金额 * 30% > 返利可用余额
      if (this.setAllocatedAmount(this.allow) > this.availableRebateAmount) {
        // 已选返利金额 > 返利可用余额
        if (Number(this.totalChoose) > this.availableRebateAmount) {
          return (this.$notify.warning('不可超过最大可用返利金额'));
        }
      } else {
        if (this.$route.query.rcontractType === '换货合同') {
          // 已选返利金额 > 订单金额 * 30%
          if (Number(this.totalChoose) > MathMulti(this.allow, 0.3)) {
            return (this.$notify.warning('不可超过最大可用返利金额'));
          }
        } else {
          // 已选返利金额 > 订单金额
          if (Number(this.totalChoose) > this.allow) {
            return (this.$notify.warning('不可超过最大可用返利金额'));
          }
        }
      }

      let list = [];
      this.multipleSelection.forEach((item) => {
        list.push({
          rebateNumber: item.rebateNumber,
          useAmount: item.transferAmount,
          availableAmount: item.availableAmount,
          strRebateType: item.strRebateType
        });
      });
      this.$emit('chooesSuccess', { list, total: this.$numToFixed(this.totalChoose) });
      this.dialogVisible = false;
    },
    transferAmountBlur (row) {
      // 比较 是否大于可使用余额
      if (row.availableAmount < row.transferAmount) {
        row.transferAmount = row.availableAmount;
        this.$notify.warning('不可超过最大可用可用余额');
      }
    }
  }
};
</script>
